import React, { useState, useEffect, useRef } from 'react';
import { useQuery } from '@apollo/client';
import { Spinner, FilterPanel } from '@gsa/afp-component-library';
import { GET_AGENCIES_BY_PERMISSION } from '../../../services/data-layer';
import { StoreSubjects } from '../../../constants/constants';

const LeasingAgencyFilterItem = ({
  filter,
  subject,
  operation,
  placeholder = '-select agency-',
}) => {
  const placeholderOption = {
    value: '',
    label: placeholder,
  };

  const optionsRef = useRef([placeholderOption]);
  const [options, setOptions] = useState(optionsRef.current);
  const { setFilters } = FilterPanel.useFilterPanel();

  const { data: agencyOptions, loading: agencyOptionsLoading } = useQuery(GET_AGENCIES_BY_PERMISSION, {
    fetchPolicy: 'no-cache',
    variables: {
      operation: operation || 'view',
      subject: subject || StoreSubjects.Order,
      order: [['agencyCode', 'ASC']],
    },
  });

  useEffect(() => {
    if (agencyOptions?.getAgenciesByPermission && optionsRef.current.length === 1) {
      const agencies = agencyOptions.getAgenciesByPermission.sort((a, b) => {
        if (a.id < b.id) return -1;
        if (a.id > b.id) return 1;
        return 0;
      }).map((agency) => ({
          value: agency.id,
          label: agency.name,
        }),
      );

      optionsRef.current = [placeholderOption, ...agencies];
      setOptions(optionsRef.current);
      setFilters({
        type: 'updateOptions',
        filter: {
          ...filter,
          options: agencies,
        },
      });
    }
  }, [agencyOptions, optionsRef.current]);

  if (agencyOptionsLoading) {
    return <Spinner />;
  }

  return (
    <FilterPanel.FilterPanelField
      key={[filter.key]}
      filter={{
        ...filter,
        type: 'select',
        options,
      }}
    />
  );
};

export default LeasingAgencyFilterItem;
